<template>
    <div class="container">
        <md-dialog :md-active.sync="modConContCuent" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }} {{ nroContrato }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col class="col-md-1 d-flex justify-content-start"></b-col>
                    <b-col class="col-md-2 d-flex justify-content-start"><h5>{{ labels.fechaIni }}</h5></b-col>
                    <b-col class="col-md-3 d-flex justify-content-start align-items-center"><h5>{{ infoContrato.fecha_inicial }}</h5></b-col>
                    <b-col class="col-md-2 d-flex justify-content-start"><h5>{{ labels.fechaFin }}</h5></b-col>
                    <b-col class="col-md-3 d-flex justify-content-start align-items-center"><h5>{{ infoContrato.fecha_final }}</h5></b-col>
                </b-row>
                <b-row class="">
                    <b-col class="col-md-1 d-flex justify-content-start"></b-col>
                    <b-col class="col-md-2 d-flex justify-content-start"><h5>{{ labels.tipoContrato }}</h5></b-col>
                    <b-col class="col-md-3 d-flex justify-content-start align-items-center"><h5>{{ tipContrat(infoContrato.tipo_contrato) }}</h5></b-col>
                    <b-col class="col-md-2 d-flex justify-content-start"><h5>{{ labels.proveedor }}</h5></b-col>
                    <b-col class="col-md-4 d-flex justify-content-start align-items-center"><h5>{{ provider(infoContrato.identificacion) }}</h5></b-col>
                </b-row>
                <b-row class="d-flex justify-content-center">
                    <!-- <b-row class="d-flex justify-content-center col-12">
                        <h1 class="md-title"><b>{{ labels.subTitle }}</b></h1>
                    </b-row> -->
                    <b-row class="d-flex justify-content-center col-11" v-if="infoCuentPorCont.length > 0">
                        <b-row class="row col-md-12 d-flex justify-content-end">
                            <md-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="genExcelSaldPorCont()">
                                <md-icon>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg>
                                </md-icon>
                            </md-button>
                        </b-row>
                        <b-table
                            :items="infoCuentPorCont"
                            :fields="fields"
                            hover
                            bordered
                            responsive
                            sticky-header="500px"
                            small
                            class="tblEstandar"
                            head-variant="custom-blue"
                            :per-page="perPage"
                            :current-page="currentPage"
                        >
                            <template #cell(cuenta)="data">
                                <div class="text-right">{{ data.item.cuenta }}</div>
                            </template>
                            <template #cell(saldo)="data">
                                <div class="text-right">{{ formatNumber(data.item.saldo) }}</div>
                            </template>
                        </b-table>
                        <div class="row col-12 mt-1">
                            <div class="col-10 d-flex justify-content-center">
                                <b-pagination
                                v-model="currentPage"
                                :per-page="perPage"
                                :total-rows="infoCuentPorCont.length"
                                :align="center"
                                size="md"
                                class="custom-pagination"
                                ></b-pagination>
                            </div>
                            <div class="col-2 d-flex justify-content-end">
                                <label class="mr-2 mb-0">Filas por página:</label>
                                <b-form-select
                                v-model="perPage"
                                :options="[2,5, 10, 20, 50, 100, 500]"
                                size="sm"
                                style="width: 80px;"
                                ></b-form-select>
                            </div>
                        </div>
                    </b-row>
                    <b-row v-else>
                        <h5>{{ labels.noRow }}</h5>
                    </b-row>
                </b-row>
                <md-dialog-actions class="">
                    <md-button class="md-accent" @click="cierraModal">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import * as XLSX from "exceljs";
import Contrato from "../../services/Contrato";
import TipoContrato from "../../services/TipoContrato";
import Tercero from "../../services/Tercero";

export default {
    name : 'ModConsxContratxCuenta',
    props : ['modConContCuent','nroContrato','vigencia','infoCuentPorCont'],
    data : () => ({
        showPorContrato : false,
        showPorCuenta : false,
        perPage: 500,
        currentPage: 1,
        fields: [
            { key: 'cuenta', label: 'Cuenta', sortable: false },
            { key: 'nombre', label: 'Descripción', sortable: false },
            { key: 'tipo_activo', label: 'Tipo activo', sortable: false },
            { key: 'centro_costo', label: 'Centro de costo', sortable: false },
            { key: 'saldo', label: 'Saldo', sortable: false },
        ],
        listaContratos : [],
        infoContrato : [],
        lstTipoCont : [],
        infoTipoCont : [],
        listTercero : [],
    }),
    computed : {
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Contrato Nro.',
                    subTitle : 'Consulta por contrato',
                    subTitleCuenta : 'Consulta por cuenta',
                    close : 'Cerrar',
                    consPorContrato : 'Consulta por contrato',
                    consPorCuenta : 'Consulta por cuenta',
                    noRow : 'No hay registros',
                    fechaIni : 'Fecha inicial:',
                    fechaFin : 'Fecha final:',
                    tipoContrato : 'Tipo contrato:',
                    proveedor : 'Proveedor:'
                }
            }else{
                return {
                    title : 'Contract Nro.',
                    subTitle : 'Contract consultation',
                    subTitleCuenta : 'Consulta por cuenta',
                    close : 'Close', 
                    consPorContrato : 'Contract consultation',
                    consPorCuenta : 'Inquiry by account',
                    noRow : 'There are no records',
                    fechaIni : 'Starting date:',
                    fechaFin : 'End date:',
                    tipoContrato : 'Contract type:',
                    proveedor : 'Provider:'
                }
            }
        }
    },
    methods : {
        cierraModal(){
            this.$emit('cierraModal',false)
        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);
        },
        tipContrat(tipCont) {
            this.infoTipoCont = this.lstTipoCont.find(tc => tc.tipo_contrato == tipCont)
            return this.infoTipoCont.descripcion
        },
        provider(identificacion){
            
            let nameTercero = this.listTercero.find((tercero) => tercero.identificacion === identificacion)

            if	(nameTercero == undefined) {
                return "Sin Nombre "+identificacion
            }
            return nameTercero.nombre
        },
        async genExcelSaldPorCont(){
            
            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Saldos por contrato")

            const titulo = ["Saldos por contrato"]
            worksheet.addRow(titulo)
            worksheet.mergeCells('A1:E1')
            worksheet.getCell('A1').font = { name: 'Arial', size: 12, bold: true }
            worksheet.getCell('A1').alignment = { horizontal: 'center' }

            // =======================
            // INFO CONTRATO
            // =======================
            const rowContrato = worksheet.addRow([
                'Contrato',
                this.nroContrato,
                '',
                'Fecha inicial',
                this.infoContrato.fecha_inicial
            ])
            // worksheet.mergeCells('F2:I2')

            // Negrita a etiquetas
            rowContrato.getCell(1).font = { name: 'Arial', size: 11, bold: true } // Contrato
            rowContrato.getCell(4).font = { name: 'Arial', size: 11, bold: true } // Fecha inicial

            const rowFechas = worksheet.addRow([
                'Tipo contrato',
                this.tipContrat(this.infoContrato.tipo_contrato),
                '',
                'Fecha final',
                this.infoContrato.fecha_final
            ])
            // worksheet.mergeCells('F3:I3')

            // Negrita a etiquetas
            rowFechas.getCell(1).font = { name: 'Arial', size: 11, bold: true } // Tipo contrato
            rowFechas.getCell(4).font = { name: 'Arial', size: 11, bold: true } // Fecha final


            const rowProeedor = worksheet.addRow([
                'Proveedor',
                this.provider(this.infoContrato.identificacion),
            ])
            worksheet.mergeCells('C4:E4')

            // Negrita a etiquetas
            rowProeedor.getCell(1).font = { name: 'Arial', size: 11, bold: true } // Proveedor

            const tituloCelda = [
                'Cuenta',
                'Descripción',
                'Tipo activo',
                'Centro de costo',
                'Saldo'
            ]

            const headerRow = worksheet.addRow(tituloCelda)

            headerRow.font = {
                name: 'Arial',
                size: 11,
                bold: true
            }

            headerRow.alignment = { horizontal: 'center' }

            this.infoCuentPorCont.map((e) => {
                worksheet.addRow([
                    e.cuenta,
                    e.nombre,
                    e.tipo_activo,
                    e.centro_costo,
                    this.formatNumber(e.saldo)
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }
            
            for( let row = 1; row <= worksheet.rowCount; row++){
                for( let col = 1; col <= worksheet.columnCount; col++){
                    worksheet.getCell(row, col).border = border;
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = "Saldos por contrato.xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            )

            downloadLink.style.display = "none";

            document.body.appendChild(downloadLink);
            downloadLink.click();

            downloadLink.remove();
        },
    },
    created(){

        TipoContrato.getAllTipoContrato()
        .then((result) => {
            // console.log(result.data.listTipoContrato);
            this.lstTipoCont = result.data.listTipoContrato
        }).catch((err) => {
            console.log(err);                
        });

        Tercero.getAllTercero()
        .then((res) => {
            this.listTercero = res.data.listTercero
        })
        .catch((err) => console.log(err))
    },
    watch:{
        nroContrato(numCont){
            if(numCont){

                Contrato.getAllContratos()
                .then((result) => {
                    this.listaContratos = result.data.listContratos
                    this.infoContrato = this.listaContratos.find((c) => c.nro_contrato == numCont)
                    // console.log(this.infoContrato);
                }).catch((err) => {
                    console.log(err);
                });
            }
        }        
    }
}
</script>

<style>

</style>